/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetGoodsLocationResponseJson } from './get-goods-location-response-json';
import { GetGoodsLocationResult } from '../results/get-goods-location-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { GoodsLocationNoDto } from '../models/goods-location-no-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetGoodsLocationResponse extends ResponseWithErrorGeneric<GetGoodsLocationResponseJson, GetGoodsLocationResult> implements IResponseWithErrorGeneric<GetGoodsLocationResult> {
  public goodsLocations: GoodsLocationNoDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetGoodsLocationResponse>) {
    super(response, GetGoodsLocationResult.Error);
    if (this.result !== GetGoodsLocationResult.Success) {
      return;
    }

    if (this.body.goodsLocations != null)
      this.goodsLocations = this.body.goodsLocations;
  }
  //</custom-body>
}
